const CloseButton = () => {

  return (
    <svg className="icon">

    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close"></use>
    </svg>
  )
}
export default CloseButton;
